import { mat4, vec3 } from "gl-matrix";

export class ViewPort {
    public width: number;
    public height: number;

    public x: number;
    public y: number;
    public z: number;

    public rotation: number;
    public lookDirection: number;

    constructor(width: number, height: number, x: number, y: number, z: number) {
        this.width = width;
        this.height = height;

        this.x = x;
        this.y = y;
        this.z = z;

        this.rotation = 0;
        this.lookDirection = 0;
    }

    public applyPerspective(matrix: mat4) {
        return mat4.perspective(matrix, 45, this.aspectRatio, 0.1, 10000.0);
    }

    public applyOrtho(matrix: mat4) {
        return mat4.ortho(matrix, -this.width / 2, this.width / 2, -this.height / 2, this.height / 2, -1.0, 10000.0);
    }

    public getPosition(): vec3 {
        return vec3.fromValues(this.x, this.y, this.z);
    }

    public get aspectRatio(): number {
        return this.width / this.height;
    }

    public toString(): string {
        return Math.round(this.x) + ', ' + Math.round(this.y) + ', ' + Math.round(this.z) + ' (' + this.width + 'x' + this.height + ')';
    }

    public applyModelView(matrix: mat4) {
        throw Error('applyModelView is not implemented for this viewport');
    }
}
